import {create} from 'zustand'

import type {TocItem} from '@sdox/ui'

export interface ToCStoreState {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  toggleOpen: () => void
  items: TocItem[]
  setItems: (items: TocItem[]) => void
  activeAnchor?: string
  setActiveAnchor: (activeAnchor: string) => void
}

export const useTocStore = create<ToCStoreState>((set) => ({
  isOpen: false,
  setOpen: (isOpen) => set(() => ({isOpen})),
  toggleOpen: () => set(({isOpen}) => ({isOpen: !isOpen})),
  items: [],
  setItems: (items) => set(() => ({items})),
  activeAnchor: undefined,
  setActiveAnchor: (activeAnchor) => set((state) => {
    if (state.items.find(item => item.anchorId === activeAnchor) !== undefined) {
      return {activeAnchor}
    }
    return {}
  }),
}))
